import { Component, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SharedService } from '@ace/ace';
import { TranslationService } from '@ace/ace';
import { filter } from 'rxjs';
import { LoaderService } from './services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  menu;
  title = 'ABG';
  isLoading: boolean = false;
  constructor(
    private renderer: Renderer2,
    private translationService: TranslationService,
    private sharedService: SharedService,
    private router: Router,
    private loaderService: LoaderService
  ) 
  {
    //this.checkScreenSize();
  }

   ngOnInit() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(async (e: NavigationEnd) => {
        this.loaderService.hideLoader();
        this.sharedService.isLoading.next(false);
        const url = e.urlAfterRedirects;
        if (url === '/login') {
          this.renderer.setAttribute(document.documentElement, 'dir', 'ltr');
        } else {
          const saved = localStorage.getItem('appLang') || 'en';
          this.renderer.setAttribute(
            document.documentElement,
            'dir',
            saved === 'ar' ? 'rtl' : 'ltr'
          );
          await this.translationService.init(saved);
        }
      });
    const initialUrl = this.router.url;
    if (initialUrl === '/login') {
      this.renderer.setAttribute(document.documentElement, 'dir', 'ltr');
    } else {
      const saved = localStorage.getItem('appLang') || 'en';
      this.renderer.setAttribute(
        document.documentElement,
        'dir',
        saved === 'ar' ? 'rtl' : 'ltr'
      );
      this.translationService.init(saved);
    }

    this.loadTheme();
    this.sharedService.isLoading.next(false);
    this.sharedService.isLoading.subscribe(l => (this.isLoading = l));
  }


  loadTheme() {
    let theme = localStorage.getItem("selectedTheme")
    if (theme == "theme1") {
      /** Light Theme **/
      const sourceColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-light');
      const sourceColor_1 = getComputedStyle(document.documentElement).getPropertyValue('--primary-light-1');
      const sourceColor_2 = getComputedStyle(document.documentElement).getPropertyValue('--primary-light-2');
      const whiteColor = getComputedStyle(document.documentElement).getPropertyValue('--white-color');
      const lightGreyColor = getComputedStyle(document.documentElement).getPropertyValue('--light-grey-color');
      const darkRedColor = getComputedStyle(document.documentElement).getPropertyValue('--dark-red');
      const blackColor = getComputedStyle(document.documentElement).getPropertyValue('--black-color');
      /* Main */
      document.documentElement.style.setProperty('--default-color', sourceColor);
      document.documentElement.style.setProperty('--default-color-1', sourceColor_1);
      document.documentElement.style.setProperty('--default-color-2', sourceColor_2);
      /* Grid */
      document.documentElement.style.setProperty('--grid-icon-color', sourceColor);
      document.documentElement.style.setProperty('--grid-bg-color', whiteColor);
      document.documentElement.style.setProperty('--grid-text-color', lightGreyColor);
      document.documentElement.style.setProperty('--grid-del-icon', darkRedColor);
      document.documentElement.style.setProperty('--grid-view-icon', sourceColor);
      document.documentElement.style.setProperty('--grid-edit-icon', sourceColor);
      document.documentElement.style.setProperty('--grid-download-icon', sourceColor);
      document.documentElement.style.setProperty('--grid-column-name-color', blackColor);
      /* Sidebar */
      document.documentElement.style.setProperty('--sidebar-bg-color', whiteColor);
      document.documentElement.style.setProperty('--sidebar-icon-color', lightGreyColor);
      document.documentElement.style.setProperty('--sidebar-selected-icon-color', sourceColor);
      /* Box Color */
      document.documentElement.style.setProperty('--box-bg-color', whiteColor);
      document.documentElement.style.setProperty('--box-text-color', blackColor);
    } else if (theme == "theme2") {
      /** Dark Theme **/
      const sourceColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-dark');
      const sourceColor_1 = getComputedStyle(document.documentElement).getPropertyValue('--primary-dark-1');
      const sourceColor_2 = getComputedStyle(document.documentElement).getPropertyValue('--primary-dark-2');
      const whiteColor = getComputedStyle(document.documentElement).getPropertyValue('--white-color');
      const lightGreyColor = getComputedStyle(document.documentElement).getPropertyValue('--light-grey-color');
      /* Main */
      document.documentElement.style.setProperty('--default-color', sourceColor);
      document.documentElement.style.setProperty('--default-color-1', sourceColor_1);
      document.documentElement.style.setProperty('--default-color-2', sourceColor_2);
      /* Grid */
      document.documentElement.style.setProperty('--grid-icon-color', whiteColor);
      document.documentElement.style.setProperty('--grid-bg-color', sourceColor);
      document.documentElement.style.setProperty('--grid-text-color', whiteColor);
      document.documentElement.style.setProperty('--grid-del-icon', whiteColor);
      document.documentElement.style.setProperty('--grid-view-icon', whiteColor);
      document.documentElement.style.setProperty('--grid-edit-icon', whiteColor);
      document.documentElement.style.setProperty('--grid-download-icon', whiteColor);
      document.documentElement.style.setProperty('--grid-column-name-color', whiteColor);
      /* Sidebar */
      document.documentElement.style.setProperty('--sidebar-bg-color', sourceColor);
      document.documentElement.style.setProperty('--sidebar-icon-color', lightGreyColor);
      document.documentElement.style.setProperty('--sidebar-selected-icon-color', whiteColor);
      /* Box Color */
      document.documentElement.style.setProperty('--box-bg-color', sourceColor);
      document.documentElement.style.setProperty('--box-text-color', whiteColor);
    }
  }
}
